import { createFileRoute, redirect } from "@tanstack/react-router";
import { CommissionsTable } from "@/app/partner/pages/commissions/CommissionsTable";
import { canAccessRoute } from "@/lib/auth";

export const Route = createFileRoute("/flex/dashboard/commissions/")({
	beforeLoad: async ({ context }) => {
		const { partner } = context;
		const access = canAccessRoute(partner, "commissions");

		if (!access.allowed) {
			throw redirect({ to: "/flex/dashboard" });
		}
	},
	component: CommissionsTable,
});
